import * as nsVue from 'vue'
import App from '../App'
import { Node } from "../models";
import hyper from "../hyper";

export default {
  functional: true,
  props: ['node'],
  render(h, context) {
    let node = context.props.node as Node | null
    let app = context.parent.$root.$children[0] as App
    let router = context.parent.$router
    let route = context.parent.$route
    let showItemsLink = node && app.itemDefinitions.map[node.type]
    let { e, div, a} = hyper(h)
    let attrs = (name: string) => { return {
      href: router.resolve({name: 'portal-'+name}, route).href,
      active$: route.name === 'portal-' + name
    }}
    return div({class: 'tab'}, [
      !showItemsLink?e: a(attrs('item-list'), '项目'),
      a(attrs('template'), '模板'),
      a(attrs('node-list'), '节点')
    ])
  }
} as nsVue.FunctionalComponentOptions


